import { SET_DASHBOARD_CUSTOMER_ID } from "constants-lib/actionTypes"

export const setDashboardCustomerId = (data) => ({
  type: SET_DASHBOARD_CUSTOMER_ID,
  payload: data,
})
